import {
    clearSelectedAssets,
    panDown,
    panLeft,
    panRight,
    panUp,
    resetPanAndZoom,
    zoomIn,
    zoomOut,
} from '../index';
import isCanvasLockEnabled from '../selectors/isCanvasLockEnabled';
import isCanvasLocked from '../selectors/isCanvasLocked';
import { setCanvasLock } from 'owa-timestream-asset-sdk-actions';
import { useGlobalHotkey } from 'owa-hotkeys';
import { useCallback } from 'react';

export default function useCanvasHotKeys() {
    // default options are: preventDefault: true, stopPropagation: true, allowHotkeyOnTextFields: false
    useGlobalHotkey('shift+=', zoomIn); // for keyboards that have `+` on top of `=` (ex: US)
    useGlobalHotkey('shift++', zoomIn); // for numeric keyboards
    useGlobalHotkey('shift+-', zoomOut); // for keyboards that have `-` next to `=` (ex: US), also on numeric keyboards
    useGlobalHotkey('ctrl+]', zoomIn, { allowHotkeyOnTextFields: true }); // for cases where `-` and `+` are not next to each other (ex: Italian), `[` and `]` are still likely to be close to each other.
    useGlobalHotkey('ctrl+[', zoomOut, { allowHotkeyOnTextFields: true });
    useGlobalHotkey('ctrl+left', panLeft);
    useGlobalHotkey('ctrl+right', panRight);
    useGlobalHotkey('ctrl+up', panUp);
    useGlobalHotkey('ctrl+down', panDown);
    useGlobalHotkey(
        'ctrl+0',
        useCallback(() => resetPanAndZoom(), []),
        { allowHotkeyOnTextFields: true }
    );
    useGlobalHotkey('esc', clearSelectedAssets, { isEnabled: disableInsidePopups });
    useGlobalHotkey('ctrl+shift+l', () => {
        if (isCanvasLockEnabled()) {
            setCanvasLock(!isCanvasLocked());
        }
    });
}

/**
 * prevents executing the callback if the focus at time of execution is inside a popup or callout. global hotkeys receive events before the actual target
 * regardless of the target stopping propagation, so this allows us to avoid forcing the target to get the event in the capture phase if we don't want the
 * function to execute inside callouts
 * @param evt
 */
function disableInsidePopups(evt: KeyboardEvent) {
    const layers = document.getElementsByClassName('ms-Layer');
    // for-loop as HTMLCollection does not support .some() or .filter()
    for (let i = 0; i < layers.length; i++) {
        if (layers[i].contains(evt.target as HTMLElement)) {
            return false;
        }
    }
    return true;
}
